const Tos = () => {
  return (
    <div className="m-5">
      <h2 className="c5 c17 c10">TERMS OF USE</h2>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c0">Effective Date: 1/1/2023</span>
      </p>
      <p className="c6">
        <span className="c0">Last Updated: 1/1/2023</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c10">
          These Terms of Use (the &ldquo;Terms&rdquo;) govern your use of the
          website at Zing.it (the &ldquo;Website&rdquo;) and the Services (as
          defined below) offered by zeNFT, Inc., a California corporation
          (&ldquo;zeNFT,&rdquo; &ldquo;us,&rdquo; &ldquo;our,&rdquo;
          &ldquo;we&rdquo;). Please read these Terms and our Privacy Policy
          carefully. &nbsp;We are a web-based platform facilitating interactions
          between users to transact with non-fungible tokens
          (&ldquo;NFTs&rdquo;) in a peer-to-peer fashion (the
          &ldquo;Services&rdquo;).
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c4 c8">NOTICE REGARDING ARBITRATION</span>
        <span className="c5 c17 c10">
          . THESE TERMS CONTAIN IMPORTANT INFORMATION THAT MAY AFFECT YOUR LEGAL
          RIGHTS. AS OUTLINED BELOW, THEY INCLUDE A MANDATORY ARBITRATION
          AGREEMENT AND CLASS ACTION WAIVER WHICH (WITH LIMITED EXCEPTIONS)
          REQUIRES ANY DISPUTES BETWEEN US TO BE RESOLVED THROUGH INDIVIDUAL
          ARBITRATION RATHER THAN BY A JUDGE OR JURY IN COURT.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c3">
        <span className="c4 c8">Agreement to Terms</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          By using or accessing the Services, you agree to be bound by these
          Terms. If you do not agree to be bound by these Terms, you are not
          authorized to access or use the Services. If you are accessing or
          using the Services on behalf of a company (such as your employer) or
          other legal entity, you represent and warrant that you have the
          authority to bind that entity to these Terms. In that case,
          &ldquo;you&rdquo; and &ldquo;your&rdquo; will also refer to that
          entity.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Privacy Policy</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          Please refer to our&nbsp;Privacy Policy for information about how we
          collect, use, and share personal data about you. By submitting
          personal data through our Services, you agree to the terms of
          our&nbsp;Privacy Policy and you expressly consent to the collection,
          use, and disclosure of your personal data in accordance with
          the&nbsp;Privacy Policy.{" "}
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Who May Use Services</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You must be at least 18 years old to agree to these Terms and use the
          Services. By using or accessing the Services, you represent and
          warrant to us that: (i) you are at least 18 years old, (ii) you are
          not currently suspended or are not permanently banned from the
          Services; and (iii) your registration and your use of the Services
          complies with any and all applicable laws and regulations. We reserve
          the right, at any time, at our sole discretion, to block, suspend,
          restrict or terminate access to some or all of the Services from
          certain users.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          Without limiting the foregoing, by using the Services, you represent
          and warrant that: (a) you are not located in, ordinarily resident in,
          or organized under the laws of any jurisdiction that is subject to a
          comprehensive U.S. Government embargo (&ldquo;Embargoed
          Jurisdiction&rdquo;); (b) you are not subject to any sanctions
          administered by an agency of the U.S. Government, any other
          government, or the United Nations (collectively,
          &ldquo;Sanctions&rdquo;); (c) you are not owned or controlled,
          directly or indirectly, by any person that is subject to Sanctions, or
          that is located in, ordinarily resident in, or organized under the
          laws of, any Embargoed Jurisdiction; (d) none of your officers,
          managers, directors, shareholders or authorized representatives is
          subject to Sanctions, or is located in, ordinarily resident in, or
          organized under the laws of, any Embargoed Jurisdiction, or is owned
          or controlled, directly or indirectly, by any person that is subject
          to Sanctions or that is located in, ordinarily resident in, or
          organized under the laws of, any Embargoed Jurisdiction. You further
          covenant that the foregoing shall be true during the entire period of
          these Terms. If you access or use the Services outside the United
          States, you are solely responsible for ensuring that your access and
          use of the Services in such country, territory or jurisdiction does
          not violate any applicable laws.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8">Account; Wallet</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c10">
          In order to register an account on the Services (&ldquo;
        </span>
        <span className="c8 c10">Account</span>
        <span className="c10">
          &rdquo;), you must link and use a digital asset wallet (&ldquo;
        </span>
        <span className="c8 c10">Wallet</span>
        <span className="c10">
          &rdquo;). You are solely responsible for maintaining the
          confidentiality of your Account and you accept responsibility for all
          activities that occur under your Account. If you believe that your
          Account is no longer secure, then you should immediately notify us at{" "}
        </span>
        <span className="c14 c10">
          <a href="mailto:info@zing.it?subject=Insecure%20Account%20Information">
            info@zing.it
          </a>
          .
        </span>
        <span className="c0">&nbsp;</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          By using a Wallet in connection with the Services, you agree that you
          are using the Wallet under the terms and conditions of the applicable
          provider of the Wallet. Wallets are not operated by, maintained by, or
          affiliated with zeNFT, and zeNFT accepts no responsibility for, or
          liability to you, in connection with your use of a Wallet. You are
          solely responsible for keeping your Wallet secure and you should never
          share your Wallet credentials with anyone. If you discover an issue
          related to your Wallet, please contact your Wallet provider.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8">Buyers and Sellers; Purchase Terms</span>
        <span className="c0">&nbsp;</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          The purchase and sale of NFTs on our Website and in connection with
          the Services are subject to terms directly between buyers and sellers
          (&ldquo;Purchase Terms&rdquo;). zeNFT is not a party to any such
          Purchase Terms. The buyer and seller are entirely responsible for
          communicating, promulgating, agreeing to, and enforcing Purchase
          Terms. In furtherance of the foregoing, you are solely responsible for
          conducting research on an NFT before purchasing, as well as
          understanding seller&rsquo;s terms and conditions of the potential
          purchase or sale of the NFT, prior to purchase or sale. We do not
          endorse any NFT nor do we make any claims regarding the authenticity,
          ownership, uniqueness, intellectual property, licenses, scarcity,
          rarity, value, functionality and/or other attributes or rights
          thereto.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          Transactions between sellers and buyers on the Website occur on a
          peer-to peer basis on one or more public blockchains. We are not
          responsible for activities occurring on such public blockchains,
          including, but not limited to, faulty recordation or non-recordation
          of a transaction on the public blockchains; &nbsp;fees imposed by the
          public blockchains, which fees are variable and may increase at any
          time; network congestion; technical upgrades or changes to the public
          blockchains; and/or technical problems on the public blockchains,
          smart contracts or protocols. &nbsp;Blockchain transactions are
          irreversible and we do not have the ability to reverse any such
          transactions or related fees. We will have no liability to you or to
          any third party for any claims or damages that may arise as a result
          of the actions of the seller, buyer, and/or public blockchains and/or
          any third-party services.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8">Fees; Taxes</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          Services on the Website may be subject to platform fees, and you
          acknowledge that we may earn a portion of those fees from your use of,
          or access to, the Services. Third parties may also charge fees for
          third party services that they provide to you when you elect to use
          such services in connection with the Website. Also, buying, selling or
          transferring NFTs on the Website may be subject to additional fees,
          including, without limitation, a royalty fee to the NFT creator. In
          addition, interactions with the relevant blockchain network(s) may
          also result in transaction fees imposed by such network(s), which are
          also solely your responsibility and may increase at any time. You will
          be solely responsible for understanding and paying all fees. You
          acknowledge and understand that we may at any time, and at our sole
          discretion, change (e.g., increase or decrease), add or remove one or
          more fees in connection with any Services, with or without advance
          notice to you.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You are solely responsible for all costs incurred by you in using the
          Services and determining, collecting, reporting and paying all
          applicable Taxes. As used herein, &ldquo;Taxes&rdquo; means the taxes,
          duties, levies, tariffs, and other governmental charges that you may
          be required by law to collect and remit to governmental agencies, and
          other similar municipal, state, federal and national indirect or other
          withholding and personal or corporate income taxes. You are solely
          responsible for maintaining all relevant Tax records and complying
          with any reporting requirements you may have related to our Services.
          You are further solely responsible for independently maintaining the
          accuracy of any record submitted to any tax authority including any
          information derived from the Services. We reserve the right to report
          any activity occurring using the Services to relevant tax authorities
          as required under applicable law.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c5">Ownership; Proprietary Rights</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          The Services and all content and other materials contained therein,
          including, without limitation, the zeNFT logo and all designs, text,
          graphics, pictures, data, software, sound files, other files, and the
          selection and arrangement thereof are the proprietary property of
          zeNFT or our affiliates, licensors, or users, as applicable, and you
          agree not to take any action(s) inconsistent with such ownership
          interests. We and our affiliates, licensors, and users, as applicable,
          reserve all rights in connection with the Services and its content,
          including, without limitation, the exclusive right to create
          derivative works. zeNFT&rsquo;s name, logo, trademarks, and any zeNFT
          product or service names, designs, logos, and slogans are the
          intellectual property of zeNFT or our affiliates or licensors and may
          not be copied, imitated or used, in whole or in part, without our
          prior written permission in each instance.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          All other third-party trademarks, registered trademarks, and product
          names mentioned on the Services or contained in the content linked to
          or associated with any NFTs displayed on the Services are the property
          of their respective owners and may not be copied, imitated or used, in
          whole or in part, without the permission of the applicable
          intellectual property rights holder.{" "}
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">
          License to Access and Use Our Services and Content
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You are hereby granted a limited, nonexclusive, nontransferable,
          nonsublicensable, and personal license to access and use the Services
          provided, however, that such license is subject to your compliance
          with these Terms. If any software, content, or other materials owned
          by, controlled by, or licensed to us are distributed or made available
          to you as part of your use of the Services, we hereby grant you a
          non-commercial, personal, non-assignable, non-sublicensable,
          non-transferrable, and non-exclusive right and license to access and
          display such software, content, and materials provided to you as part
          of the Services, in each case for the sole purpose of enabling you to
          use the Services as permitted by these Terms, provided that your
          license in any content linked to or associated with any NFTs is solely
          as set forth by the applicable seller or creator of such NFT.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Third-Party Websites</span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c3">
        <span className="c0">
          The Services may contain links to third-party websites or otherwise
          display, include, or make available content, data, information,
          services, applications, or materials from third parties. Such
          third-party websites and materials are not under the control of zeNFT,
          and zeNFT is not responsible or liable for any third-party websites
          and materials. zeNFT does not review, approve, monitor, endorse,
          warrant, or make any representations with respect to third-party
          websites, or their products or services. You use all links in
          third-party websites and materials at your own risk.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Prohibited Uses of the Services</span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c6">
        <span className="c0">
          In using the Services, you agree that you will not:
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0 start">
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use the Services for any illegal purpose or in violation of any
            local, state, national, or international law.{" "}
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Perform any fraudulent activity including impersonating any person
            or entity, claiming a false affiliation, accessing any other
            user&rsquo;s Account without permission, or falsifying your age or
            date of birth;{" "}
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use the Services in a manner that could damage, disable, overburden,
            or impair the functioning of the Services in any way;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Harass, threaten, demean, embarrass, bully, or otherwise harm any
            other user of the Services;{" "}
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use our Services for commercial purposes inconsistent with these
            Terms (including advertising or direct marketing activity) or any
            other instructions, or to carry out any financial activities subject
            to registration or licensing, including but not limited to creating,
            offering, selling, or buying securities, commodities, options, or
            debt instruments;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use any data mining, robot, spider, crawler, scraper, script,
            browser extension, offline reader, or other automated means or
            interface not authorized by us to access the Services, extract data,
            or otherwise interfere with or modify the rendering of Services
            pages or functionality;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Reverse engineer, duplicate, decompile, disassemble, or decode any
            aspect of the Services;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use the Services for money laundering, terrorist financing, or other
            illicit finance schemes;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use the Services, directly or indirectly, for, on behalf of, or for
            the benefit of, (a) any natural or legal person that is the subject
            of Sanctions; (b) any natural or legal person located in, ordinarily
            resident in, or organized under the laws of, any Embargoed
            Jurisdiction; or (c) any legal person owned or controlled, directly
            or indirectly, by any natural or legal person located in, ordinarily
            resident in, or organized under the laws of, any Embargoed
            Jurisdiction.
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Infringe or violate the intellectual property rights or any other
            rights of others;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Create or display NFTs or other items that promote suicide or
            self-harm, incites hate or violence against others;
          </span>
        </li>
        <li className="c6 c11 li-bullet-0">
          <span className="c0">
            Use the Services in any manner that could interfere with, disrupt,
            negatively affect or inhibit other users from fully enjoying the
            Services.
          </span>
        </li>
      </ul>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          zeNFT reserves the right to act, with or without advance notice, if we
          believe you have violated these Terms, including disabling your
          ability to access our Services.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">User Content</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          In addition to creating and posting NFTs, the Services may permit
          users to submit, upload, publish, broadcast, or otherwise transmit
          (&ldquo;Post&rdquo;) content to the Services, including messages,
          reviews, photos, video or audio (including sound or voice recordings
          and musical recordings embodied in the video or audio), images,
          folders, data, text, and any other works of authorship or other works
          (&ldquo;User Content&rdquo;). For the avoidance of doubt, NFTs are
          User Content.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You retain any copyright and other proprietary rights that you may
          hold in the User Content that you Post to the Services except those
          rights that you explicitly choose to waive.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          By Posting User Content to or via the Services, you grant zeNFT a
          worldwide, non-exclusive, perpetual, irrevocable, royalty-free, fully
          paid right and license (with the right to sublicense through multiple
          tiers) to host, store, transfer, display, perform, reproduce, modify
          for the purpose of formatting for display, create derivative works as
          authorized in these Terms, and distribute your User Content, in whole
          or in part, in any media formats and through any media channels now
          known or hereafter developed. &nbsp;Likewise, by Posting User Content
          to or via the Services to other users of the Services, you grant those
          users a non-exclusive license to access and use that User Content as
          permitted by these Terms and the functionality of the Services.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8">
          User Content Representations and Warranties
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          zeNFT disclaims any and all liability in connection with User Content.
          You are solely responsible for your User Content and the consequences
          of providing User Content via the Services. By providing User Content
          via the Services, you affirm, represent, and warrant to us that: (a)
          you are the creator and owner of the User Content, or have the
          necessary licenses, rights, consents, and permissions to authorize
          zeNFT and users of the Services to use and distribute your User
          Content as necessary to exercise the licenses granted by you in this
          section, in the manner contemplated by zeNFT, the Services, and these
          Terms; (b) your User Content, and the Posting or other use of your
          User Content as contemplated by these Terms, does not and will not:
          (i) infringe, violate, misappropriate, or otherwise breach any
          third-party right, including any copyright, trademark, patent, trade
          secret, moral right, privacy right, right of publicity, or any other
          intellectual property, contract, or proprietary right; (ii) slander,
          defame, libel, or invade the right of privacy, publicity or other
          property rights of any other person; or (iii) cause zeNFT to violate
          any law or regulation or require us to obtain any further licenses
          from or pay any royalties, fees, compensation or other amounts or
          provide any attribution to any third parties; and (c) your User
          Content could not be deemed by a reasonable person to be
          objectionable, profane, indecent, pornographic, harassing,
          threatening, embarrassing, hateful, or otherwise inappropriate.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8">Monitoring User Content</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          We are under no obligation to edit or control User Content that you or
          other users Post and will not be in any way responsible or liable for
          User Content. zeNFT may, however, at any time and without prior
          notice, screen, remove, edit, or block any User Content in our sole
          discretion, including pursuant to our judgment that it violates these
          Terms. You agree to waive, and do waive, any legal or equitable right
          or remedy you have or may have against zeNFT with respect to User
          Content. If notified by a user or content owner that User Content
          allegedly does not conform to these Terms, we may investigate the
          allegation and determine in our sole discretion whether to remove the
          User Content, which we reserve the right to do at any time and without
          notice. If at any time zeNFT chooses to monitor User Content, zeNFT
          still assumes no responsibility or liability for such content, or any
          loss or damage incurred as a result of the use of such content. During
          monitoring, information may be examined, recorded, copied, and used in
          accordance with our Privacy Policy.{" "}
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Indemnification</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          By agreeing to these Terms and accessing the Services, you agree, to
          the fullest extent permitted by applicable law, to indemnify, defend,
          and hold harmless zeNFT, and our respective past, present, and future
          employees, officers, directors, contractors, consultants, equity
          holders, suppliers, vendors, service providers, parent companies,
          subsidiaries, affiliates, agents, representatives, predecessors,
          successors, and assigns (individually and collectively, the
          &ldquo;zeNFT Parties&rdquo;), from and against all actual or alleged
          claims, damages, awards, judgments, losses, liabilities, obligations,
          taxes, penalties, interest, fees, expenses (including, without
          limitation, attorneys&rsquo; fees and expenses), and costs (including,
          without limitation, court costs, costs of settlement, and costs of
          pursuing indemnification and insurance), of every kind and nature
          whatsoever, whether known or unknown, foreseen or unforeseen, matured
          or unmatured, or suspected or unsuspected, in law or equity, whether
          in tort, contract, or otherwise (collectively, &ldquo;Claims&rdquo;),
          including, but not limited to, damages to property or personal injury,
          that are caused by, arise out of or are related to (a) your use or
          misuse of the Services, content, NFTs, or content linked to or
          associated with any NFTs (b) your violation or breach of any term of
          these Terms or applicable law, and (c) your violation of the rights of
          or obligations to a third party, including another user or
          third-party, (d) your negligence or willful misconduct, and (e) User
          Content. You agree to promptly notify zeNFT of any Claims and
          cooperate with the zeNFT parties in defending such Claims. You further
          agree that the zeNFT parties shall have control of the defense or
          settlement of any Claims.{" "}
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Disclaimers</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          ZENFT MAKES NO REPRESENTATIONS OR WARRANTIES AS TO THE QUALITY,
          ORIGIN, OR OWNERSHIP OF ANY CONTENT FOUND IN THE SERVICES, INCLUDING
          USER CONTENT. ZENFT WILL NOT BE LIABLE FOR ANY ERRORS,
          MISREPRESENTATIONS, OR OMISSIONS IN, OF, AND ABOUT, THE CONTENT, NOR
          FOR THE AVAILABILITY OF THE CONTENT. ZENFT WILL NOT BE LIABLE FOR ANY
          LOSSES, INJURIES, OR DAMAGES FROM THE PURCHASE, INABILITY TO PURCHASE,
          DISPLAY, OR USE OF CONTENT, INCLUDING USER CONTENT.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          ALL INFORMATION PROVIDED BY OR ON BEHALF OF ZENFT IN CONNECTION WITH
          THE SERVICES IS FOR INFORMATIONAL PURPOSES ONLY AND SHOULD NOT BE
          CONSTRUED AS PROFESSIONAL, ACCOUNTING, FINANCIAL, LEGAL OR REGULATORY
          ADVICE. WE ENCOURAGE YOU TO SEEK INDEPENDENT PROFESSIONAL ADVICE FROM
          PERSONS LICENSED AND QUALIFIED IN THE AREA FOR WHICH SUCH ADVICE WOULD
          BE APPROPRIATE BEFORE ACCESSING AND USING OUR SERVICES.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          YOUR ACCESS TO AND USE OF THE SERVICES IS AT YOUR OWN RISK. YOU
          UNDERSTAND AND AGREE THAT THE SERVICES ARE PROVIDED ON AN &ldquo;AS
          IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS AND ZENFT EXPRESSLY
          DISCLAIMS WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR
          IMPLIED. ZENFT MAKES NO WARRANTY OR REPRESENTATION AND DISCLAIMS ALL
          RESPONSIBILITY FOR WHETHER THE SERVICES: (A) WILL MEET YOUR
          REQUIREMENTS; (B) WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY,
          SECURE, OR ERROR-FREE BASIS; OR (C) WILL BE ACCURATE, RELIABLE,
          COMPLETE, LEGAL, OR SAFE. ZENFT DISCLAIMS ALL OTHER WARRANTIES OR
          CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED
          WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, TITLE AND NON-INFRINGEMENT. ZENFT WILL NOT BE LIABLE FOR ANY
          LOSS OF ANY KIND FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE ON
          MATERIAL OR INFORMATION, CONTAINED ON THE SERVICES. WHILE ZENFT
          ATTEMPTS TO MAKE YOUR ACCESS TO AND USE OF THE SERVICES SAFE, ZENFT
          CANNOT AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICES, CONTENT,
          CONTENT LINKED TO OR ASSOCIATED WITH ANY NFTS, OR ANY NFTS YOU
          INTERACT WITH USING OUR SERVICES OR OUR SERVICE PROVIDERS&rsquo;
          SERVERS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          YOU BEAR FULL RESPONSIBILITY FOR VERIFYING THE IDENTITY, LEGITIMACY,
          AND AUTHENTICITY OF DIGITAL ASSETS (INCLUDING NFTS) YOU PURCHASE OR
          SELL THROUGH THE SERVICES. ZENFT MAKE NO CLAIMS ABOUT THE IDENTITY,
          LEGITIMACY, OR AUTHENTICITY OF DIGITAL ASSETS ON THE SERVICES.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          EXCEPT FOR THE EXPRESS STATEMENTS SET FORTH IN THESE TERMS, YOU HEREBY
          ACKNOWLEDGE AND AGREE THAT YOU HAVE NOT RELIED UPON ANY OTHER
          STATEMENT, MATERIAL OR INFORMATION, WHETHER ORAL OR WRITTEN, WITH
          RESPECT TO YOUR ACCESS AND USE OF THE WEBSITE, SERVICES OR CONTENTS
          THEREIN. WITHOUT LIMITING THE FOREGOING, YOU HEREBY UNDERSTAND AND
          AGREE THAT ZENFT WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND FROM ANY
          ACTION TAKEN OR TAKEN IN RELIANCE ON STATEMENTS, MATERIAL OR
          INFORMATION CONTAINED ON THE SITE, SERVICES OR ANY CONTENT THEREIN.
          WHILE ZENFT ATTEMPT TO MAKE YOUR ACCESS TO AND USE OF THE SITE,
          SERVICES AND ANY CONTENT THEREIN SAFE, ZENFT CANNOT AND DO NOT
          REPRESENT OR WARRANT THAT THE WEBSITE, SERVICES AND ANY CONTENT
          THEREIN, OR ZENFT&rsquo;S SERVERS ARE FREE OF VIRUSES OR OTHER HARMFUL
          COMPONENTS. ZENFT CANNOT GUARANTEE THE SECURITY OF ANY DATA THAT YOU
          DISCLOSE ONLINE. YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING
          INFORMATION AND DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD
          ZENFT RESPONSIBLE FOR ANY BREACH OF SECURITY.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          Some jurisdictions do not allow the exclusion of implied warranties in
          contracts with consumers, so the above exclusion may not apply to you.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Limitation of Liability</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO EVENT
          WILL ZENFT BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY LOST PROFIT OR
          ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR
          PUNITIVE DAMAGES ARISING FROM THESE TERMS OR THE SERVICES, OR FOR ANY
          DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS
          OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, OR LOSS OF
          DATA, AND WHETHER CAUSED BY STRICT LIABILITY OR TORT (INCLUDING
          NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE AND
          EVEN IF ZENFT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES; OR
          (B) FOR ANY OTHER CLAIM, DEMAND, OR DAMAGES WHATSOEVER RESULTING FROM
          OR ARISING OUT OF OR IN CONNECTION WITH THESE TERMS, OR USE OR
          PERFORMANCE OF THE SERVICES. ACCESS TO, AND USE OF, THE SERVICES IS AT
          YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR
          ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE DEVICE OR LOSS OF DATA
          RESULTING THEREFROM. NOTWITHSTANDING ANYTHING TO THE CONTRARY
          CONTAINED HEREIN, IN NO EVENT SHALL THE MAXIMUM AGGREGATE LIABILITY OF
          ZENFT ARISING OUT OF OR IN ANY WAY RELATED TO THESE TERMS, THE ACCESS
          TO AND USE OF THE SERVICES EXCEED THE GREATER OF (A) $100 OR (B) THE
          AMOUNT RECEIVED BY ZENFT FOR ITS SERVICES DIRECTLY RELATING TO THE
          ITEMS THAT ARE THE SUBJECT OF THE CLAIM.{" "}
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c0">
          Some jurisdictions do not allow the exclusion or limitation of
          incidental or consequential damages, so the above limitation or
          exclusion may not apply to you. Some jurisdictions also limit
          disclaimers or limitations of liability for personal injury from
          consumer products, so this limitation may not apply to personal injury
          claims.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Assumption of Risk</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c0">
          In connection with your use of the Services, you accept and
          acknowledge:
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            The prices and liquidity of digital assets (including, not limited
            to, NFTs, cryptocurrencies, digital tokens, digital coins,
            stablecoins) are extremely volatile due to many factors including,
            but not limited to, adoption, speculation, technology, legislative,
            regulatory and case law risks, security risks, litigation, and
            bankruptcy filings and proceedings of one or more entities involved
            in digital assets and transactions or custody thereof. Fluctuations
            in the price of other digital assets could materially and adversely
            affect the digital assets made available through the Services, which
            may also be subject to significant price volatility. We cannot
            guarantee that any purchasers of digital assets will not lose money.
            You also acknowledge that the cost of transacting on blockchain
            networks is variable and may increase at any time causing impact to
            any activities taking place on the Services or blockchain networks.
            By using or accessing the Services, you acknowledge these risks and
            agree that we will not be held liable for any losses or damages
            associated with these risks including, without limitation, losses
            associated with your use of the Services, digital assets or
            blockchain networks.{" "}
          </span>
        </li>
      </ul>
      <p className="c3 c7 c18">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            You are solely responsible for determining what, if any, Taxes apply
            to your transactions through the Services. We are not responsible
            for determining the Taxes that apply to such transactions.{" "}
          </span>
        </li>
      </ul>
      <p className="c15 c7">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            The Services do not store, send, or receive digital assets. This is
            because digital assets exist only by virtue of the ownership record
            maintained on its supporting blockchain. Any transfer of digital
            assets occurs within the supporting blockchain and not on the
            Services. Transactions in digital assets (including NFTs) may be
            irreversible, and, accordingly, losses due to fraudulent or
            accidental transactions may not be recoverable. Some transactions in
            digital assets shall be deemed to be made when recorded on a public
            ledger, which is not necessarily the date or time that you initiated
            the transaction.{" "}
          </span>
        </li>
      </ul>
      <p className="c7 c18 c20">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            By accessing or using the Services, you represent that you
            understand the inherent risks associated with cryptographic systems;
            and warrant that you understand the usage and intricacies of
            blockchain, digital assets, decentralized networks, decentralized
            apps, decentralized exchanges or platforms and blockchain-based
            software systems. We are not responsible for any issues with the
            blockchains, including forks, technical node issues or any other
            issues having fund losses as a result. You acknowledge that the cost
            and speed of transacting with cryptographic and blockchain-based
            systems are variable and may increase at any time. You further
            acknowledge the risk that your digital assets may lose some or all
            of their value while they are supplied to or from the Services. You
            further acknowledge that we are not responsible for any of these
            variables or risks and cannot be held liable for any resulting
            losses that you experience while accessing Services. Accordingly,
            you understand and agree to assume full responsibility for all of
            the risks of accessing and using and interacting with the Services.{" "}
          </span>
        </li>
      </ul>
      <p className="c3 c7 c18">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            There are risks associated with using an Internet-based digital
            asset, including but not limited to, the risk of hardware, software
            and Internet connections, the risk of malicious software
            introduction, and the risk that third parties may obtain
            unauthorized access to information stored within Wallet. Our
            Services rely on emerging technologies, which may change or become
            non-operational due to third party activity (including, without
            limitation, technical upgrades or non-upgrades; service or technical
            disruption or failure; retiring or decommissioning software or
            system; and close of business) and without prior notice to you or
            zeNFT. You accept and acknowledge that zeNFT will not be responsible
            for any communication failures, disruptions, errors, distortions or
            delays you may experience when using the Services, however caused.{" "}
          </span>
        </li>
      </ul>
      <p className="c7 c15">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            A lack of use or public interest in the creation and development of
            distributed ecosystems could negatively impact the development of
            those ecosystems and related applications, and could therefore also
            negatively impact the potential utility or value of a certain
            digital asset.{" "}
          </span>
        </li>
      </ul>
      <p className="c15 c7">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            zeNFT, digital assets, digital asset wallets, blockchain networks
            and digital asset-related exchanges and marketplaces could be
            impacted by one or more legislative actions, regulatory actions
            (such as regulatory investigations or enforcement actions) or
            judiciary actions (such as court orders and decisions) that could
            impede or limit the ability of zeNFT to continue to develop, or
            which could impede or limit your ability to access or use the
            Services and any other blockchain networks and/or digital wallets.
            The legal and regulatory regimes and case law governing blockchain
            technologies, digital assets, including, but not limited to, NFTs,
            are uncertain and evolving, and new or revised laws, regulations or
            policies may materially adversely affect one or more digital assets
            and/or the Services. By using or accessing the Services, you
            acknowledge these risks and agree that we will not be held liable
            for any losses or damages associated with these risks including,
            without limitation, losses associated with your use of Services,
            digital assets or blockchain networks.{" "}
          </span>
        </li>
      </ul>
      <p className="c15 c7">
        <span className="c0"></span>
      </p>
      <ul className="c2 lst-kix_list_11-0">
        <li className="c1 li-bullet-0">
          <span className="c0">
            There are risks associated with purchasing user generated content,
            including but not limited to, the risk of purchasing counterfeit
            assets, mislabeled assets, assets with unauthorized content, assets
            that are vulnerable to metadata decay, assets on smart contracts
            with bugs or malware, and assets that may become untransferable.
            zeNFT reserves the right to remove, disable, restrict or make
            inaccessible assets affected by any of these issues or by other
            issues, without notice to you. Assets you purchase may become
            inaccessible. You agree that under no circumstances shall the
            inability to view or access your assets serve as grounds for a claim
            against zeNFT.{" "}
          </span>
        </li>
      </ul>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c4 c8 c12">Dispute Resolution; Arbitration</span>
      </p>
      <p className="c6 c7 c12">
        <span className="c0"></span>
      </p>
      <p className="c3 c12">
        <span className="c4">Dispute Resolution</span>
        <span className="c0">
          .&nbsp;Please read the following arbitration agreement in this Section
          (&ldquo;Arbitration Agreement&rdquo;) carefully. It requires you to
          arbitrate disputes with zeNFT and limits the manner in which you can
          seek relief from us. This section does not govern disputes between
          users or between users and third parties. zeNFT does not provide
          dispute resolution services for such disagreements and the parties
          must resolve those disputes directly.
        </span>
      </p>
      <p className="c6 c7 c12">
        <span className="c0"></span>
      </p>
      <p className="c6 c9">
        <span className="c4">Applicability of Arbitration Agreement</span>
        <span className="c0">
          .&nbsp;You agree that any dispute, controversy, or claim relating in
          any way to your access or use of the Services or to any aspect of your
          relationship with zeNFT, will be resolved by binding arbitration,
          rather than in court, including threshold questions of the
          arbitrability of such dispute, controversy, or claim except that (1)
          you or zeNFT may assert claims in small claims court, but only if the
          claims qualify, the claims remain only in such court, and the claims
          remain on an individual, non-representative, and non-class basis; and
          (2) you or zeNFT may seek injunctive or equitable relief in a court of
          proper jurisdiction if the claim relates to intellectual property
          infringement or other misuse of intellectual property rights.
        </span>
      </p>
      <p className="c6 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Dispute Resolution Process</span>
        <span className="c0">
          .&nbsp;You and zeNFT both agree to engage in good-faith efforts to
          resolve disputes prior to either party initiating an arbitration,
          small claims court proceeding, or equitable relief for intellectual
          property infringement. You must initiate this dispute resolution
          process by sending a letter describing the nature of your claim and
          desired resolution to the address in the Contact Us section below.
          Both parties agree to meet and confer personally, by telephone, or by
          videoconference (hereinafter &ldquo;Conference&rdquo;) to discuss the
          dispute and attempt in good faith to reach a mutually beneficial
          outcome that avoids the expenses of arbitration or, where applicable,
          litigation. If you are represented by counsel, your counsel may
          participate in the Conference as well, but you agree to fully
          participate in the Conference. Likewise, if zeNFT is represented by
          counsel, its counsel may participate in the Conference as well, but
          zeNFT agrees to have a company representative fully participate in the
          Conference. The statute of limitations and any filing fee deadlines
          shall be tolled while the parties engage in the informal dispute
          resolution process and Conference required by this paragraph. If the
          parties do not reach agreement to resolve the dispute within thirty
          (30) days after initiation of this dispute resolution process, either
          party may commence arbitration, file an action in small claims court,
          or file a claim for injunctive or equitable relief in a court of
          proper jurisdiction for matters relating to intellectual property
          infringement, if the claims qualify.
        </span>
      </p>
      <p className="c6 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Arbitration Rules and Forum</span>
        <span className="c0">
          .&nbsp;The Federal Arbitration Act governs the interpretation and
          enforcement of this Arbitration Agreement. To begin an arbitration
          proceeding after participating in the dispute resolution process, you
          must send a letter requesting arbitration and describing your claim to
          us at the address listed in the Contact Us section below. The
          arbitration will be conducted by JAMS, an established alternative
          dispute resolution provider. If JAMS is not available to arbitrate,
          the parties will select an alternative arbitral forum. If the
          arbitrator finds that you cannot afford to pay JAMS filing,
          administrative, hearing, and/or other fees and cannot obtain a waiver
          from JAMS, zeNFT will pay them for you if you complied with the
          dispute resolution process set forth above. In addition, zeNFT will
          reimburse all such JAMS filing, administrative, hearing, and/or other
          fees for claims totaling less than $10,000 unless the arbitrator
          determines the claims are frivolous or you did not comply with the
          dispute resolution process set forth above, except that if you have
          initiated the arbitration claim, you will still be required to pay the
          lesser of $250 or the maximum amount permitted under the JAMS Rules
          for arbitration claims initiated by you. You are still responsible for
          all additional costs that you incur in the arbitration, including
          without limitation, fees for attorneys or expert witnesses. You may
          choose to have the arbitration conducted by telephone or
          videoconference, based on written submissions, in person in your
          hometown area (if you live in the United States), or at another
          mutually agreed upon location that is reasonably convenient to you.
          Any judgment on the award rendered by the arbitrator may be entered in
          any court of competent jurisdiction.
        </span>
      </p>
      <p className="c6 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Authority of Arbitrator</span>
        <span className="c0">
          .&nbsp;The arbitrator shall have exclusive authority to (a) determine
          the scope and enforceability of this Arbitration Agreement and (b)
          resolve any dispute related to the interpretation, applicability,
          enforceability, or formation of this Arbitration Agreement including,
          but not limited to, any claim that all or any part of this Arbitration
          Agreement is void or voidable. The arbitration will decide the rights
          and liabilities, if any, of you and zeNFT. The arbitration proceeding
          will not be consolidated with any other matters or joined with any
          other cases or parties. The arbitrator shall have the authority to
          grant motions dispositive of all or part of any claim. The arbitrator
          shall have the authority to award monetary damages and to grant any
          non-monetary remedy or relief available to an individual under
          applicable law, the arbitral forum&rsquo;s rules, and these Terms. The
          arbitrator shall issue a written award and statement of decision
          describing the essential findings and conclusions on which the award
          is based, including the calculation of any damages awarded. The
          arbitrator has the same authority to award relief on an individual
          basis that a judge in a court of law would have. The award of the
          arbitrator is final and binding upon you and us.
        </span>
      </p>
      <p className="c6 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Waiver of Jury Trial</span>
        <span className="c0">
          .&nbsp;YOU AND ZENFT HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY
          RIGHTS TO SUE IN COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY.
          You and zeNFT are instead electing that all claims and disputes shall
          be resolved by arbitration under this Arbitration Agreement, except as
          specified in the second bullet of this section, above
          (&ldquo;Applicability of Arbitration Agreement&rdquo;). An arbitrator
          can award on an individual basis the same damages and relief as a
          court and must follow these Terms as a court would. However, there is
          no judge or jury in arbitration, and court review of an arbitration
          award is subject to very limited review.
        </span>
      </p>
      <p className="c6 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">
          Waiver of Class Actions and Class Arbitrations
        </span>
        <span className="c0">
          .&nbsp;ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION
          AGREEMENT MUST BE ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A
          REPRESENTATIVE (INCLUDING, WITHOUT LIMITATION, PRIVATE ATTORNEYS
          GENERAL ACT) OR COLLECTIVE CLASS BASIS. ONLY INDIVIDUAL RELIEF IS
          AVAILABLE, AND CLAIMS OF MORE THAN ONE USER, PERSON, OR ENTITY CANNOT
          BE ARBITRATED OR CONSOLIDATED WITH THOSE OF ANY OTHER USER, PERSON, OR
          ENTITY. Accordingly, under the arbitration procedures outlined in this
          section, an arbitrator shall not combine or consolidate more than one
          party&rsquo;s claims without the written consent of all affected
          parties to an arbitration proceeding. Without limiting the generality
          of the foregoing, you and zeNFT agree that no dispute shall proceed by
          way of class arbitration without the written consent of all affected
          parties. If a decision is issued stating that applicable law precludes
          enforcement of any part of this subsection&rsquo;s limitations as to a
          given claim for relief, then that claim must be severed from the
          arbitration and brought in the state or federal courts located in
          Alameda County in the State of California. All other claims shall be
          arbitrated.
        </span>
      </p>
      <p className="c3 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Severability</span>
        <span className="c0">
          .&nbsp;Except as provided in this Section, if any part or parts of
          this Arbitration Agreement are found under the law to be invalid or
          unenforceable, then such specific part or parts shall be of no force
          and effect and shall be severed and the remainder of the Arbitration
          Agreement shall continue in full force and effect.
        </span>
      </p>
      <p className="c3 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Survival of Agreement</span>
        <span className="c0">
          .&nbsp;This Arbitration Agreement will survive the termination of your
          relationship with zeNFT.
        </span>
      </p>
      <p className="c3 c9 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c9">
        <span className="c4">Modification</span>
        <span className="c0">
          .&nbsp;Notwithstanding any provision in these Terms to the contrary,
          we agree that if zeNFT makes any future material change to this
          Arbitration Agreement, you may reject that change within thirty (30)
          days of such change becoming effective by writing to zeNFT at the
          address in the Contact Us section below.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Governing Law and Venue</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          These Terms and your access to and use of the Services shall be
          governed by and construed and enforced in accordance with the laws of
          the State of California (without regard to conflict of law rules or
          principles of the State of California, or any other jurisdiction that
          would cause the application of the laws of any other jurisdiction).
          Any dispute between the parties shall be resolved in the state or
          federal courts of Alameda County in the State of California, and the
          United States, respectively, sitting in the State of California.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Termination</span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          If you breach any of the provisions of these Terms, all licenses
          granted by zeNFT will terminate automatically. Additionally,
          notwithstanding anything contained in these Terms, we reserve the
          right, with or without notice and in our sole discretion, to suspend,
          disable, terminate, or delete your account and/or your ability to
          access or use the Services (or any part of the foregoing) at any time
          and for any or no reason, and you acknowledge and agree that we shall
          have no liability or obligation to you in such event and that you will
          not be entitled to a refund of any amounts that you have already paid
          to us.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Severability</span>
      </p>
      <p className="c3 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c3">
        <span className="c0">
          If any term, clause, or provision of these Terms is held invalid or
          unenforceable, then that term, clause, or provision will be severable
          from these Terms and will not affect the validity or enforceability of
          any remaining part of that term, clause, or provision, or any other
          term, clause, or provision of these Terms.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Injunctive Relief</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You agree that a breach of these Terms will cause irreparable injury
          to zeNFT for which monetary damages would not be an adequate remedy
          and zeNFT shall be entitled to equitable relief in addition to any
          remedies it may have hereunder or at law without a bond, other
          security, or proof of damages.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Export Laws</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          You agree that you will not export or re-export, directly or
          indirectly, the Services, and/or other information or materials
          provided by zeNFT hereunder, to any country for which the United
          States or any other relevant jurisdiction requires any export license
          or other governmental approval at the time of export without first
          obtaining such license or approval.{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Survival</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          All sections which by their nature should survive the termination of
          these Terms shall continue in full force and effect subsequent to and
          notwithstanding any termination of these Terms by zeNFT or you.
          Termination will not limit any of zeNFT&rsquo;s other rights or
          remedies at law or in equity.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Modifications to the Services</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          We reserve the right in our sole discretion to modify, suspend, or
          discontinue, temporarily or permanently, the Services (or any features
          or parts thereof) at any time and without liability as a result.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Miscellaneous</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          These Terms constitute the entire agreement between you and zeNFT
          relating to your access to and use of the Services. These Terms, and
          any rights and licenses granted hereunder, may not be transferred or
          assigned by you without the prior written consent of zeNFT, and
          zeNFT&rsquo;s failure to assert any right or provision under these
          Terms shall not constitute a waiver of such right or provision. No
          waiver by either party of any breach or default hereunder shall be
          deemed to be a waiver of any preceding or subsequent breach or
          default. The section headings used herein are for reference only and
          shall not be read to have any legal effect. Except as otherwise
          provided herein, these Terms are intended solely for the benefit of
          the parties and are not intended to confer third-party beneficiary
          rights upon any other person or entity.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c5 c4">Copyright Notice</span>
      </p>
      <p className="c3 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          zeNFT will take down works in response to Digital Millennium Copyright
          Act (&ldquo;DMCA&rdquo;) takedown notices and/or other intellectual
          property infringement claims and will terminate a user&#39;s access to
          the Services if the user is determined to be a repeat infringer. If
          you believe that your content has been copied in a way that
          constitutes copyright or trademark infringement, or violates your
          publicity or other intellectual property rights, you may submit
          written notice to our designated copyright agent at:
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c0">zeNFT, Inc.</span>
      </p>
      <p className="c6">
        <span className="c0">3179 College Ave Suite 2B</span>
      </p>
      <p className="c6">
        <span className="c0">Berkeley, CA 94705</span>
      </p>
      <p className="c6">
        <span className="c0 c14">
          Email:{" "}
          <a href="mailto:info@zing.it?subject=Copyright%20Violation">
            info@zing.it
          </a>
        </span>
      </p>
      <p className="c6">
        <span className="c14 c10">
          Phone: <a href="tel:5102924220">510-292-4220</a>
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c3">
        <span className="c0">
          For us to process your infringement claim regarding content on the
          Services, you must be the rightsholder or someone authorized to act on
          behalf of the rightsholder. Your notice must include: (a)
          Identification of the copyrighted work(s), trademark, publicity
          rights, or other intellectual property rights that you claim is being
          infringed; (b) Identification of the allegedly infringing material
          that is requested to be removed, including a description of the
          specific location (i.e., urls) on the Services of the material claimed
          to be infringing, so that we may locate the material; (c) Your contact
          information &ndash; at a minimum, your full legal name (not pseudonym)
          and email address; (d) A declaration that contains all of the
          following: (i) A statement that you have a good faith belief that use
          of the material in the manner complained of is not authorized by the
          intellectual property rights owner, its agent, or the law; (ii) A
          statement that the information in the notice is accurate; (iii) A
          statement under penalty of perjury that you are authorized to act on
          behalf of the intellectual property owner of the intellectual property
          that is allegedly being infringed; and (iv) Your physical or
          electronic signature (of your full legal name).
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Modification of Terms</span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c3">
        <span className="c0">
          zeNFT reserves the right to change or modify these Terms at any time
          and in our sole discretion. If we make material changes to these
          Terms, we will use reasonable efforts to provide notice of such
          changes, such as by providing notice through the Services or updating
          the &ldquo;Last Updated&rdquo; date at the beginning of these Terms.
          By continuing to access or use the Services, you confirm your
          acceptance of the revised Terms and all of the terms incorporated
          therein by reference effective as of the date these Terms are updated.
          It is your sole responsibility to review the Terms from time to time
          to view such changes and to ensure that you understand the terms and
          conditions that apply when you access or use the Services.
        </span>
      </p>
      <p className="c6 c7">
        <span className="c0"></span>
      </p>
      <p className="c6">
        <span className="c5 c4">Contact Us</span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
      <p className="c12 c16">
        <span className="c10">
          Please direct any inquiries and comments to zeNFT, Inc., 3179 College
          Ave., Suite 2B, Berkeley, CA 94705 or email at{" "}
        </span>
        <span className="c14 c10">
          <a href="mailto:info@zing.it?subject=Personal%20Information">
            info@zing.it
          </a>
          .
        </span>
      </p>
      <p className="c6 c7">
        <span className="c5 c4"></span>
      </p>
    </div>
  );
};
export default Tos;
